import dayjs from "dayjs";
import { TruckVendorApi } from "../../services";
import styles from "./FreightCosts.module.scss";

export const getUpdateGroupContractorsConfig = ({
  apiDebounceRoute,
  routeBaseWatch,
  truckVendorGroupWatch,
}: any) => ({
  dataSource: {
    table: `posts`,
    update: {
      isBackendData: false,
    },
  },
  fields: [
    {
      label: "Mã tuyến",
      dataIndex: "routeBase",
      displayType: "SelectOption",
      col: { span: 12 },
      rules: [
        {
          required: true,
          message: "Không được để trống phần này",
        },
      ],
      input: {
        showSearch: true,
        fetchOptions: apiDebounceRoute,
        placeholder: "Chọn mã tuyến",
      },
    },
    {
      label: "Nhóm",
      dataIndex: "truckVendorGroup",
      displayType: "SelectOption",
      col: { span: 12 },
      rules: [
        {
          required: true,
          message: "Không được để trống phần này",
        },
      ],
      input: {
        showSearch: true,
        fetchOptions: (search: string) => {
          return TruckVendorApi.getAllTruckVendorGroup({
            searchText: search,
          }).then((res) =>
            res?.data?.map((ite: any) => ({
              label: `${ite.groupName} (${ite.truckVendors?.length} nhà thầu)`,
              value: ite._id,
            })),
          );
        },
        placeholder: "Chọn nhóm",
      },
    },
    {
      label: "Phiên bản",
      dataIndex: "version",
      displayType: "Input",
      col: { span: 12 },
      input: {
        disabled: true,
      },
    },
    {
      label: "Ngày hiệu lực",
      dataIndex: "versionValidFrom",
      displayType: "Input",
      col: { span: 12 },
      input: {
        disabled: true,
      },
    },
    {
      label: "Cont 20",
      dataIndex: "cont20",
      displayType: "InputNumber",
      col: { span: 8 },
      rules: [],
      input: {
        formatter: (value: number) =>
          `${value}đ`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        disabled: !(routeBaseWatch && truckVendorGroupWatch),
      },
    },
    {
      label: "Cont 40",
      dataIndex: "cont40",
      displayType: "InputNumber",
      col: { span: 8 },
      rules: [],
      input: {
        formatter: (value: number) =>
          `${value}đ`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        disabled: !(routeBaseWatch && truckVendorGroupWatch),
      },
    },
    {
      label: "Cont 45",
      dataIndex: "cont45",
      displayType: "InputNumber",
      col: { span: 8 },
      rules: [],
      input: {
        formatter: (value: number) =>
          `${value}đ`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        disabled: !(routeBaseWatch && truckVendorGroupWatch),
      },
    },
    {
      label: "20",
      dataIndex: "cy20",
      displayType: "InputNumber",
      col: { span: 8 },
      rules: [],
      input: {
        formatter: (value: number) =>
          `${value}đ`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        disabled: !(routeBaseWatch && truckVendorGroupWatch),
      },
    },
    {
      label: "40",
      dataIndex: "cy40",
      displayType: "InputNumber",
      col: { span: 8 },
      rules: [],
      input: {
        formatter: (value: number) =>
          `${value}đ`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        disabled: !(routeBaseWatch && truckVendorGroupWatch),
      },
    },
    {
      label: "45",
      dataIndex: "cy45",
      displayType: "InputNumber",
      col: { span: 8 },
      rules: [],
      input: {
        formatter: (value: number) =>
          `${value}đ`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        disabled: !(routeBaseWatch && truckVendorGroupWatch),
      },
    },
    {
      label: "Phí giao nhận",
      displayType: "Group",
      dataIndex: "group5",
      col: { span: 24 },
      divider: true,
      className: [styles.FormItem].join(" "),
      fields: [
        {
          label: "Xuất",
          dataIndex: "deliveryCostExport",
          displayType: "InputNumber",
          col: { span: 12 },
          rules: [],
          input: {
            formatter: (value: number) =>
              `${value}đ`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            disabled: !(routeBaseWatch && truckVendorGroupWatch),
          },
        },
        {
          label: "Nhập",
          dataIndex: "deliveryCostImport",
          displayType: "InputNumber",
          col: { span: 12 },
          rules: [],
          input: {
            formatter: (value: number) =>
              `${value}đ`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            disabled: !(routeBaseWatch && truckVendorGroupWatch),
          },
        },
      ],
    },
    {
      label: "Phụ cước",
      displayType: "Group",
      dataIndex: "group5",
      col: { span: 24 },
      divider: true,
      className: [styles.FormItem].join(" "),
      fields: [
        {
          label: "Xuất",
          dataIndex: "extraFeeExport",
          displayType: "InputNumber",
          col: { span: 12 },
          rules: [],
          input: {
            formatter: (value: number) =>
              `${value}đ`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            disabled: !(routeBaseWatch && truckVendorGroupWatch),
          },
        },
        {
          label: "Nhập",
          dataIndex: "extraFeeImport",
          displayType: "InputNumber",
          col: { span: 12 },
          rules: [],
          input: {
            formatter: (value: number) =>
              `${value}đ`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            disabled: !(routeBaseWatch && truckVendorGroupWatch),
          },
        },
      ],
    },
    {
      label: "Kẹp lệch cont20",
      dataIndex: "splitCont20",
      displayType: "InputNumber",
      col: { span: 8 },
      rules: [],
      input: {
        formatter: (value: number) =>
          `${value}đ`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        disabled: !(routeBaseWatch && truckVendorGroupWatch),
      },
    },
  ],
});

export const getConfigInputImportForm = ({
  dataVersion,
  formInstance,
  selectedName,
  onCopy,
}: any) => ({
  dataSource: {
    table: `posts`,
    update: {
      isBackendData: false,
    },
  },
  fields: [
    {
      displayType: "Group",
      dataIndex: "_id",
      col: { span: 24 },
      divider: true,
      className: [styles.FormItem].join(" "),
      fields: [
        {
          label: "Phiên bản",
          dataIndex: "name",
          displayType: "Select",
          col: { span: 12 },
          rules: [
            {
              required: true,
              message: "Không được để trống phần này",
            },
          ],
          input: {
            onChange: (name: any) => {
              if (name !== "new") {
                const selectedVersion: any = dataVersion.find(
                  (item: any) => item._id === name,
                );
                formInstance.setFieldsValue({
                  validFrom: selectedVersion
                    ? dayjs(selectedVersion?.validFrom)
                    : null,
                });
              } else {
                formInstance.setFieldsValue({ validFrom: null });
              }
            },
            options: [
              {
                label: "Phiên bản mới",
                value: "new",
              },
              ...(dataVersion?.length > 0
                ? dataVersion.map((item: any) => ({
                    label: item.name,
                    value: item._id,
                  }))
                : []),
            ],
          },
        },
        {
          label: "Ngày hiệu lực",
          dataIndex: "validFrom",
          displayType: "DatePicker",
          col: { span: 12 },
          rules: [
            {
              required: true,
              message: "Không được để trống phần này",
            },
          ],
          input: {
            disabled: selectedName !== "new",
            style: { width: "100%" },
          },
        },
        {
          label: "Sao chép từ phiên bản cũ",
          dataIndex: "onCopy",
          displayType: "SwitchToggle",
          col: { span: 12 },
          rules: [],
          input: {},
        },
        {
          label: "Phiên bản cần sao chép",
          dataIndex: "cloneFromVersion",
          displayType: "Select",
          col: { span: 12 },
          rules: [
            {
              required: !!onCopy,
              message: "Chưa chọn phiên bản cần sao chép",
            },
          ],
          input: {
            disabled: !onCopy,
            options: [
              ...(dataVersion?.length > 0
                ? dataVersion.map((item: any) => ({
                    label: item.name,
                    value: item._id,
                  }))
                : []),
            ],
          },
        },
      ],
    },
  ],
});
